import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { isValid, parseISO } from 'date-fns';
import { getUser } from '../../redux/user/actions';

export const getLockedDashboardTimeRange = preferences => {
  const range = preferences?.lockedDashboardTimeRange;
  const timestamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
  if (!range || ![range.startTime, range.endTime].every(value =>
    typeof value === 'string' && timestamp.test(value) && isValid(parseISO(value))
  ) || parseISO(range.startTime) > parseISO(range.endTime)) return null;

  return {
    startDate: range.startTime,
    endDate: range.endTime,
    startTime: range.startTime,
    endTime: range.endTime,
    isTimeRangeLocked: true
  };
};

// Derive the effective range before rendering or fetching, including preference changes.
export const useDashboardFilters = initialFilters => {
  const [filters, setFilters] = useState(initialFilters);
  const preferences = useSelector(getUser)?.preferences;
  const appliedFilters = useMemo(() => {
    const lockedRange = getLockedDashboardTimeRange(preferences);
    return filters ? { ...filters, ...lockedRange,
      ...(lockedRange && preferences?.timezone ? { timezone: preferences.timezone } : {}),
      isTimeRangeLocked: Boolean(lockedRange) } : filters;
  }, [filters, preferences]);
  return [appliedFilters, setFilters];
};
